import * as ExcelJS from 'exceljs';

/**
 * 기본 엑셀 스타일
 * @public
 */
export const defaultStyle: Partial<ExcelJS.Style> = {
  border: {
    top: {style: 'thin', color: {argb: '000000'}},
    bottom: {style: 'thin', color: {argb: '000000'}},
    left: {style: 'thin', color: {argb: '000000'}},
    right: {style: 'thin', color: {argb: '000000'}},
  },
  font: {size: 9, color: {argb: '000000'}},
  alignment: {
    vertical: 'middle',
    horizontal: 'center',
    wrapText: true,
  },
  fill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'ffffff'},
  },
};

/**
 * 기본 엑셀 스타일 (폰트 크기 11)
 * @public
 */
export const defaultStyleFont11: Partial<ExcelJS.Style> = {
  border: {
    top: {style: 'thin', color: {argb: '000000'}},
    bottom: {style: 'thin', color: {argb: '000000'}},
    left: {style: 'thin', color: {argb: '000000'}},
    right: {style: 'thin', color: {argb: '000000'}},
  },
  font: {size: 11, color: {argb: '000000'}},
  alignment: {
    vertical: 'middle',
    horizontal: 'center',
    wrapText: true,
  },
  fill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: {argb: 'ffffff'},
  },
};
